import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

const STORIES = [
  {
    quote:
      "Edubridge handled my SOP, my visa file and even my hostel at Manchester. I just had to focus on my grades.",
    name: "Ananya Sharma",
    meta: "MSc Data Science · University of Manchester, UK",
    initials: "AS",
    slug: "ananya",
  },
  {
    quote:
      "The loan team got my sanction letter before the admission deadline. That speed changed everything for my family.",
    name: "Rohan Mehta",
    meta: "BEng Mechanical · University of Toronto, Canada",
    initials: "RM",
    slug: "rohan",
  },
  {
    quote:
      "The mock interviews made the embassy round feel easy. My visa came through in eleven days.",
    name: "Simran Kaur",
    meta: "MPharm · Monash University, Australia",
    initials: "SK",
    slug: "simran",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" data-testid="testimonials-section" className="container-x py-20 lg:py-32">
      <SectionHeading
        overline="Student stories"
        title={
          <>
            File after file, <span className="italic text-mint">visa stamps.</span>
          </>
        }
      />

      <div data-testid="testimonials-grid" className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3 lg:gap-6">
        {STORIES.map((t, i) => (
          <motion.figure
            key={t.slug}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
            data-testid={`testimonial-card-${t.slug}`}
            className="group flex h-full flex-col justify-between rounded-[28px] border border-white/10 bg-surface p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-mint/40 lg:p-9"
          >
            <div>
              <Quote className="h-7 w-7 text-mint/60" strokeWidth={1.5} />
              <blockquote className="mt-5 font-display text-xl font-light italic leading-relaxed text-frost/90">
                {t.quote}
              </blockquote>
            </div>
            <figcaption className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-mint/40 bg-ink font-mono text-sm text-mint">
                {t.initials}
              </span>
              <div>
                <p className="text-sm font-bold text-frost">{t.name}</p>
                <p className="mt-0.5 text-xs leading-relaxed text-mist">{t.meta}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
